import React, { FC } from 'react'

import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Typography from '@material-ui/core/Typography'

import PhoneIcon from '@material-ui/icons/Phone'
import PrintIcon from '@material-ui/icons/Print'
import Link from '@material-ui/core/Link'
import LaunchIcon from '@material-ui/icons/Launch'
import LinkedInIcon from '@material-ui/icons/LinkedIn'
import FacebookIcon from '@material-ui/icons/Facebook'
import { components } from '@plandi/common/src/generated'
import { useTranslation } from '@plandi/common'
import { useProfileDetailsStyles } from './profile-details.styles'
import { ReactComponent as VkIcon } from 'public/assets/icons/bx_bxl-vk.svg'

type ProfileSocialProps = {
  type: string | string[] | undefined
  profileFreelancer?: components['schemas']['ProfileSpecialistMeResource']
  profileCompany?: components['schemas']['ProfileCompanyMeResource']
  profileFactory?: components['schemas']['ProfileFactoryMeResource']
}

export const ProfileSocial: FC<ProfileSocialProps> = ({
  profileFactory,
  type,
  profileCompany,
  profileFreelancer
}) => {
  const classes = useProfileDetailsStyles()
  const { data: translate } = useTranslation()

  const profile =
    type === 'freelancer'
      ? profileFreelancer
      : type === 'company'
      ? profileCompany
      : profileFactory

  const renderSocial = () => {
    return (
      <>
        <Typography
          variant="subtitle1"
          color="primary"
          className={classes.title}
        >
          {translate?.shop?.['contact-details'] ?? 'Контактные данные'}
        </Typography>
        {profile?.socialNetwork?.phone && (
          <div className={classes.textWrap}>
            <PhoneIcon fontSize="small" className={classes.icon} />
            <Link
              href={`tel:${profile?.socialNetwork?.phone}`}
              color="textPrimary"
            >
              <Typography variant="body2" component="span">
                {profile?.socialNetwork?.phone}
              </Typography>
            </Link>
          </div>
        )}
        {profile?.socialNetwork?.fax && (
          <div className={classes.textWrap}>
            <PrintIcon fontSize="small" className={classes.icon} />
            <Link
              href={`tel:${profile?.socialNetwork?.fax}`}
              color="textPrimary"
            >
              <Typography variant="body2" component="span">
                {profile?.socialNetwork?.fax}
              </Typography>
            </Link>
          </div>
        )}
        {profile?.socialNetwork?.siteUrl && (
          <Link
            href={profile?.socialNetwork?.siteUrl}
            color="textPrimary"
            target="_blank"
            className={classes.textWrap}
          >
            <LaunchIcon fontSize="small" className={classes.icon} />
            <Typography variant="body2" component="span" color="primary" noWrap>
              {profile?.socialNetwork?.siteUrl}
            </Typography>
          </Link>
        )}
        {profile?.socialNetwork?.linkedin && (
          <div className={classes.textWrap}>
            <LinkedInIcon fontSize="small" className={classes.icon} />
            <Link href={profile?.socialNetwork?.linkedin} target="_blank">
              <Typography variant="body2" component="span">
                Linkedin
              </Typography>
            </Link>
          </div>
        )}
        {profile?.socialNetwork?.facebook && (
          <div className={classes.textWrap}>
            <FacebookIcon fontSize="small" className={classes.icon} />
            <Link href={profile?.socialNetwork?.facebook} target="_blank">
              <Typography variant="body2" component="span">
                Facebook
              </Typography>
            </Link>
          </div>
        )}
        {profile?.socialNetwork?.vk && (
          <div className={classes.textWrap}>
            <VkIcon fontSize="small" className={classes.icon} />
            <Link href={profile?.socialNetwork?.vk} target="_blank">
              <Typography variant="body2" component="span">
                VK
              </Typography>
            </Link>
          </div>
        )}
      </>
    )
  }

  return (
    <Card className={classes.card}>
      <CardContent>{renderSocial()}</CardContent>
    </Card>
  )
}
